/* lystia-search.js - пошук (T-E5-07, parity/search.md). Підключення: <script src="{{ 'lystia-search.js' | asset_url }}" defer> ПІСЛЯ lystia-core.js.
   <lystia-search> живе у двох місцях: сторінка /search (sections/main-search.liquid, атрибут data-search-page) і тіло оверлея `search` на D (sections/search-panel.liquid).
   A-072: підказки під час набору - нативний Predictive Search (Section Rendering GET /search/suggest?section_id=search-suggest, товари/колекції/статті, limit 6, unavailable_products=last),
   від 2 символів, debounce 250 мс, попередній запит скасовується (AbortController), відповіді кешуються на сторінку. Порожній стан і idle (чіпи/історія) - фрагмент [data-search-results]
   секції main-search з /search (id інстансу береться з першої повної відповіді). Enter/«Показати всі» ведуть на нативну /search?q= (там і лічильник, і повний список).
   Історія запитів: document.lystia.store, ключ `searchHistory` (lystia:searchHistory), до 6, запис від 2 символів, без демо-значень. */
(function () {
  'use strict';
  const core = document.lystia;
  if (!core) { console.error('[lystia-search] потрібен lystia-core.js (document.lystia)'); return; }
  if (customElements.get('lystia-search')) return;

  const HIST_KEY = 'searchHistory';
  const HIST_MAX = 6;
  const MIN_Q = 2;
  const LIMIT = 6;
  const DEBOUNCE = 250;
  const mqHover = window.matchMedia('(hover: hover)');
  const cache = new Map(); /* url|q -> HTML-рядок вмісту [data-search-results] */
  const pending = new Map(); /* ключ -> Promise (спільний префетч) */

  const getHist = () => { const v = core.store.get(HIST_KEY, null); return Array.isArray(v) ? v : []; };
  const setHist = (a) => core.store.set(HIST_KEY, a.slice(0, HIST_MAX));
  const pushHist = (q) => {
    q = String(q || '').trim();
    if (q.length < MIN_Q) return;
    setHist([q].concat(getHist().filter((x) => String(x).toLowerCase() !== q.toLowerCase())));
  };

  /* section_id шаблонного інстансу (template--…__main) невідомий поза /search: беремо його з першої повної відповіді (data-section). */
  const ids = new Map(); /* url -> section id */

  function fragmentUrl(url, section, q) {
    const p = new URLSearchParams();
    if (q) {
      p.set('q', q);
      p.set('type', 'product,article');
      p.set('options[prefix]', 'last');
      p.set('options[unavailable_products]', 'last');
    }
    if (section) p.set('section_id', section);
    const qs = p.toString();
    return qs ? url + (url.indexOf('?') < 0 ? '?' : '&') + qs : url;
  }

  function suggestUrl(base, q) {
    const p = new URLSearchParams();
    p.set('q', q);
    p.set('section_id', 'search-suggest');
    p.set('resources[type]', 'product,collection,article');
    p.set('resources[limit]', String(LIMIT));
    p.set('resources[limit_scope]', 'each');
    p.set('resources[options][unavailable_products]', 'last');
    return base + (base.indexOf('?') < 0 ? '?' : '&') + p.toString();
  }

  const parse = (html) => new DOMParser().parseFromString(html, 'text/html');

  /* Завантажити внутрішній HTML [data-search-results] з /search (idle при q='' або «нічого не знайшли» для q). signal - необов'язково. */
  function loadFragment(url, q, signal) {
    const key = url + '|' + q;
    if (cache.has(key)) return Promise.resolve(cache.get(key));
    if (!signal && pending.has(key)) return pending.get(key);
    const pr = fetch(fragmentUrl(url, ids.get(url), q), { signal: signal, credentials: 'same-origin', headers: { Accept: 'text/html' } })
      .then((r) => { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
      .then((html) => {
        const doc = parse(html);
        const box = doc.querySelector('[data-search-results]');
        if (!box) throw new Error('немає [data-search-results] у відповіді');
        const host = doc.querySelector('lystia-search[data-search-page]');
        if (host && host.getAttribute('data-section')) ids.set(url, host.getAttribute('data-section'));
        cache.set(key, box.innerHTML);
        return box.innerHTML;
      })
      .finally(() => { pending.delete(key); });
    if (!signal) pending.set(key, pr);
    return pr;
  }

  /* Нативний Predictive Search: HTML підказок; порожня відповідь -> стан «Нічого не знайшли» з /search. */
  function loadSuggest(el, q, signal) {
    const key = 'suggest|' + q.toLowerCase();
    if (cache.has(key)) return Promise.resolve(cache.get(key));
    return fetch(suggestUrl(el.suggestUrl, q), { signal: signal, credentials: 'same-origin', headers: { Accept: 'text/html' } })
      .then((r) => { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
      .then((html) => {
        const box = parse(html).querySelector('[data-search-suggest]');
        if (!box) throw new Error('немає [data-search-suggest] у відповіді');
        if (!box.hasAttribute('data-empty')) return box.innerHTML;
        return loadFragment(el.url, q, signal);
      })
      .then((html) => { cache.set(key, html); return html; });
  }

  class LystiaSearch extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;
      this.page = this.hasAttribute('data-search-page');
      this.url = this.getAttribute('data-url') || '/search';
      if (this.page && this.getAttribute('data-section')) ids.set(this.url, this.getAttribute('data-section'));
      this.suggestUrl = this.getAttribute('data-suggest-url') || '/search/suggest';
      this.form = this.querySelector('[data-search-form]');
      this.input = this.querySelector('[data-search-input]');
      this.clearBtn = this.querySelector('[data-search-clear]');
      this.cancelEl = this.querySelector('[data-search-cancel]');
      this.results = this.querySelector('[data-search-results]');
      if (!this.form || !this.input || !this.results) return;
      this.q = this.input.value || '';
      this.token = 0;
      this.ctrl = null;
      this.debounced = core.debounce(() => this.load(this.q.trim()), DEBOUNCE);

      this.input.addEventListener('input', () => this.setQ(this.input.value));
      this.form.addEventListener('submit', (e) => {
        /* від 2 символів - нативна сторінка результатів /search?q= (форма GET), інакше нічого */
        if (this.input.value.trim().length < MIN_Q) { e.preventDefault(); return; }
        pushHist(this.input.value);
      });
      if (this.clearBtn) this.clearBtn.addEventListener('click', () => { this.input.value = ''; this.setQ(''); this.focusInput(); });
      if (this.cancelEl) this.cancelEl.addEventListener('click', (e) => this.onCancel(e));
      this.results.addEventListener('click', (e) => this.onResultsClick(e));

      if (this.results.children.length) this.afterRender(); /* SSR-стан сторінки */
      else this.load(this.q.trim());

      if (this.page && mqHover.matches) this.focusInput();
    }

    focusInput() { try { this.input.focus({ preventScroll: true }); } catch (e) { /* ignore */ } }

    setQ(q, immediate) {
      this.q = q;
      if (this.clearBtn) this.clearBtn.hidden = !q;
      if (this.page) {
        try { history.replaceState(history.state, '', location.pathname + (q ? '?q=' + encodeURIComponent(q) : '')); } catch (e) { /* ignore */ }
      }
      const t = q.trim();
      if (t.length < MIN_Q) { if (this.ctrl) this.ctrl.abort(); this.load(''); } else if (immediate) this.load(t); else this.debounced();
    }

    pick(q) {
      this.input.value = q;
      pushHist(q);
      this.setQ(q, true);
    }

    onCancel(e) {
      if (this.page) {
        if (history.length > 1) { e.preventDefault(); history.back(); }
        return; /* інакше - перехід за href (колекція каталогу) */
      }
      e.preventDefault();
      if (document.lystiaOverlay) document.lystiaOverlay.close();
    }

    onResultsClick(e) {
      const t = e.target;
      if (!t.closest) return;
      const chip = t.closest('[data-search-q]');
      if (chip) { e.preventDefault(); this.pick(chip.getAttribute('data-search-q')); return; }
      const hq = t.closest('[data-hist-q]');
      if (hq) { this.pick(hq.getAttribute('data-q') || ''); return; }
      const hx = t.closest('[data-hist-x]');
      if (hx) {
        const q = hx.getAttribute('data-q') || '';
        setHist(getHist().filter((x) => x !== q));
        this.renderHistory();
        return;
      }
      if (t.closest('a[href]') && t.closest('[data-search-grid], .cs-top, .cs-links, .cs-all')) pushHist(this.q);
    }

    load(q) {
      if (this.ctrl) this.ctrl.abort();
      const ctrl = new AbortController();
      this.ctrl = ctrl;
      const token = ++this.token;
      this.results.setAttribute('aria-busy', 'true');
      const req = q.length >= MIN_Q ? loadSuggest(this, q, ctrl.signal) : loadFragment(this.url, '', ctrl.signal);
      return req.then((html) => {
        if (token !== this.token) return;
        const t = document.createElement('template');
        t.innerHTML = html;
        this.results.replaceChildren(t.content);
        this.results.removeAttribute('aria-busy');
        this.afterRender();
      }).catch((err) => {
        if (err && err.name === 'AbortError') return;
        if (token === this.token) this.results.removeAttribute('aria-busy');
        console.warn('[lystia-search]', err);
      });
    }

    afterRender() {
      this.renderHistory();
    }

    renderHistory() {
      const sec = this.results.querySelector('[data-search-history]');
      if (!sec) return;
      const list = sec.querySelector('[data-search-history-list]');
      const tpl = sec.querySelector('template[data-search-history-row]');
      const tmpl = this.getAttribute('data-remove-label') || '';
      const hist = getHist();
      list.replaceChildren();
      if (tpl) {
        hist.forEach((q) => {
          const row = tpl.content.cloneNode(true);
          const bq = row.querySelector('[data-hist-q]');
          const bx = row.querySelector('[data-hist-x]');
          bq.setAttribute('data-q', q);
          bq.querySelector('span').textContent = q;
          bx.setAttribute('data-q', q);
          bx.setAttribute('aria-label', tmpl.replace('__Q__', q));
          list.appendChild(row);
        });
      }
      sec.hidden = !hist.length;
    }
  }
  customElements.define('lystia-search', LystiaSearch);

  /* ---- Оверлей D: позиція під хедером, початковий запит, фокус (parity/search.md §3.4) ---- */
  core.on('overlay-open', (d) => {
    if (!d || d.name !== 'search' || !d.panel) return;
    const el = d.panel.querySelector('lystia-search');
    if (!el) return;
    const ov = d.panel.closest('.ov');
    if (ov && core.device() === 'desktop') {
      const hd = document.getElementById('header');
      const r = hd && hd.getBoundingClientRect();
      ov.style.top = r && r.top >= 0 ? Math.round(r.bottom) + 'px' : '0px';
    }
    if (d.props && d.props.q && el.input) { el.input.value = d.props.q; el.setQ(d.props.q, true); }
    if (core.device() === 'desktop') setTimeout(() => { if (el.isConnected) el.focusInput(); }, 60);
  });

  /* ---- Префетч порожнього стану для оверлея: перед відкриттям (наведення/фокус/дотик на іконку пошуку) ---- */
  const prefetch = () => {
    const host = document.querySelector('lystia-overlay[name="search"] template[data-slot="body"]');
    if (!host) return;
    const t = host.content.querySelector('lystia-search');
    if (!t) return;
    loadFragment(t.getAttribute('data-url') || '/search', '').catch(() => {});
  };
  ['pointerover', 'focusin', 'touchstart'].forEach((evt) => {
    document.addEventListener(evt, (e) => { if (e.target.closest && e.target.closest('[data-header-search]')) prefetch(); }, { passive: true, capture: true });
  });
})();
